/**
 * Lenis smooth scroll — minimal setup.
 * @see https://github.com/darkroomengineering/lenis
 */

import Lenis from 'lenis';
import 'lenis/dist/lenis.css';

const REDUCED_MOTION_MQ = '(prefers-reduced-motion: reduce)';

/** @type {Lenis | null} */
let lenis = null;

/** @type {Set<() => void>} */
const scrollListeners = new Set();

function notifyScrollListeners() {
	scrollListeners.forEach((listener) => listener());
}

export function getScrollY() {
	return lenis ? lenis.scroll : window.scrollY;
}

export function getLenis() {
	return lenis;
}

export function onLenisScroll(listener) {
	scrollListeners.add(listener);
	return () => scrollListeners.delete(listener);
}

export function initLenis() {
	if (lenis || window.matchMedia(REDUCED_MOTION_MQ).matches) {
		return lenis;
	}

	lenis = new Lenis({
		autoRaf: true,
		duration: 1.1,
		smoothWheel: true,
		syncTouch: false,
	});

	lenis.on('scroll', notifyScrollListeners);

	const bodyClassObserver = new MutationObserver(() => {
		if (!lenis) {
			return;
		}
		if (document.body.classList.contains('no-scroll')) {
			lenis.stop();
		} else {
			lenis.start();
		}
	});
	bodyClassObserver.observe(document.body, {
		attributes: true,
		attributeFilter: ['class'],
	});

	return lenis;
}

document.addEventListener('DOMContentLoaded', initLenis);
